// Shared section wrappers for /early-stage — Figma page 8068:50299 uses 80px
// horizontal page padding and white bordered containers with grid connectors.
// Connector placement follows page-rail junctions — see `/grid-connectors` skill.

import { BorderedFrame } from "@/components/blocks/bordered-frame";
import type { RailConnectorEdge } from "@/components/blocks/bordered-frame";
import { cn } from "@/lib/utils";

interface EarlyStageSectionProps {
  children: React.ReactNode;
  className?: string;
  /** Extra classes on the outer grey-50 section shell. */
  sectionClassName?: string;
  id?: string;
  dataTestId?: string;
}

/** Standard page section shell — px-20 (80px) at lg per Figma. */
export function EarlyStageSection({
  children,
  className,
  sectionClassName,
  id,
  dataTestId,
}: EarlyStageSectionProps) {
  return (
    <section
      id={id}
      data-testid={dataTestId}
      className={cn(
        "bg-grey-50 px-6 md:px-8 lg:px-20",
        sectionClassName,
        className
      )}
    >
      {children}
    </section>
  );
}

/** @deprecated Use `BorderedFrame` from `@/components/blocks/bordered-frame`. */
export type { RailConnectorEdge };

interface EarlyStageBorderedFrameProps {
  children: React.ReactNode;
  className?: string;
  connectors?: RailConnectorEdge | "none";
}

/** White bordered container — re-exports shared `BorderedFrame`. */
export function EarlyStageBorderedFrame({
  children,
  className,
  connectors = "none",
}: EarlyStageBorderedFrameProps) {
  return (
    <BorderedFrame className={className} connectors={connectors}>
      {children}
    </BorderedFrame>
  );
}
